import axios from "axios"
import baseURLConfig from "./envConfig";

const API = axios.create({
    baseURL: baseURLConfig.baseURL
})
export default API;